import styled from 'styled-components';
import { ProjectTable } from '../../molecules/ProjectTable/ProjectTable.styled';
import { medias } from '@/utils/sizes';
import { TComponentWidth } from '@/types/global';
import { generateClampFromMinMax } from '@/utils/styling';

export const Columns = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: var(--spacing-component-inner);

  ${medias.max.tablet} {
    display: grid;
    grid-template-columns: 100%;
    gap: var(--info-column-spacing-mobile);
    /* gap: var(--spacing-inner-vertical-mobile-tablet); */
    margin-left: 0;
    max-width: 850px;
  }

  ${medias.max.mobile} {
    grid-template-columns: 100%;
  }
`;

export const Column = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['span', 'componentWidth', 'pageType'].includes(prop),
})<{
  span: number;
  componentWidth: TComponentWidth;
  pageType: 'project' | 'page';
}>`
  --info-column-spacing-mobile: 20.5px;

  grid-column: span ${(props) => props.span};
  width: ${(props) => props.span};

  ${ProjectTable} {
    box-sizing: border-box;
    padding-right: ${generateClampFromMinMax(80, 190)};

    ${medias.max.tablet} {
      padding-right: 0;
    }
  }

  ${medias.max.tablet} {
    grid-column: span 2;

    .info-text {
      padding-top: 0;
    }

    /* .info-text {
      padding-top: 0;
      padding-bottom: var(--spacing-inner-vertical-mobile-tablet);
    }

    .info-column {
      padding-bottom: var(--info-column-spacing-mobile);

      &:last-child {
        padding-bottom: 0;
      }
    } */
  }

  ${medias.max.tablet} {
    p:not(.table-key, .table-value) {
      padding: 0;
    }

    &:last-child p {
      padding-bottom: 0;
    }

    .info-columns .info-column:first-child {
      margin-bottom: var(--spacing-component-inner);
    }

    .info-text {
      padding-bottom: var(--info-column-spacing-mobile);

      &:last-child {
        padding-bottom: 0;
      }
    }

    padding-bottom: var(--info-column-spacing-mobile);

    &:last-child {
      padding-bottom: 0;
    }
  }
`;
